<div class="container" data-meta="category-list-container" aria-hidden="false">
  <mat-card appearance="outlined" data-section="category-list" data-random="c4t1">
    <mat-card-title data-element="category-title">Category List</mat-card-title>

    <!-- Add Category Button -->
    <button
      style="position: absolute; right: 15px; top: 8px; width: 35px; height: 35px;"
      [ngClass]="isAdminGroupUser ? 'mat-mini-fab mat-accent' : 'mat-mini-fab mat-button-disabled'"
      color="accent"
      tabindex="0"
      matTooltip="Add Product Category"
      (click)="onAddCategoryClick()"
      aria-label="Add Category"
      data-role="add-category"
      mat-fab
      data-tracking="add-cat-btn"
      [disabled]="isAdminGroupUser === false"
    >
      <span class="mat-mdc-button-wrapper" data-icon="add">
        <i class="material-icons" style="font-size: 30px;" data-placeholder="plus">add</i>
      </span>
    </button>

    <!-- Download Button -->
    <button
      style="position: absolute; right: 55px; top: 8px; width: 35px; height: 35px;"
      *ngIf="categories != null && categories.length > 0"
      (click)="onDownloadCategoriesClick()"
      color="accent"
      matTooltip="Download Records"
      aria-label="Download Categories"
      mat-fab
      data-role="download-categories"
      data-extra="download-cat-btn"
    >
      <span class="mat-mdc-button-wrapper" data-icon="download">
        <i class="material-icons" style="font-size: 30px;" data-placeholder="download">download</i>
      </span>
    </button>

    <mat-card-subtitle data-marker="subtitle"></mat-card-subtitle>

    <!-- Filter Section -->
    <div class="row" data-area="filters" aria-live="polite">
      <div class="col-md-9" data-container="filter-left"></div>
      <div class="col-md-3" data-container="filter-right">
        <app-filter-input
          *ngIf="categories != null && categories.length > 0"
          (filterChanged)="applyCategoryFilter($event)"
          data-component="filter-input"
        ></app-filter-input>
      </div>
    </div>

    <mat-card-content data-body="content-area">
      <div class="table-responsive" data-wrapper="table-area" aria-live="assertive">
        <table
          *ngIf="categories != null && categories.length > 0"
          mat-table
          [dataSource]="dataSource"
          matSort
          (matSortChange)="announceCategorySort($event)"
          class="mat-elevation-z8"
          aria-label="Table listing categories"
          data-table-id="category-table"
        >
          <!-- Serial Number Column -->
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef data-header="serial">S No.</th>
            <td mat-cell *matCellDef="let element; let i = index;" data-cell="serial">
              {{
                (i + 1) +
                ((pageEvent?.pageSize || paginator.pageSize) *
                (pageEvent?.pageIndex || paginator.pageIndex))
              }}
            </td>
          </ng-container>

          <!-- categoryId column -->
          <ng-container matColumnDef="categoryId">
            <th mat-header-cell *matHeaderCellDef data-header="cat-id"></th>
            <td mat-cell *matCellDef="let element" data-cell="cat-id">{{ element.categoryId }}</td>
          </ng-container>

          <!-- productId column -->
          <ng-container matColumnDef="productId">
            <th mat-header-cell *matHeaderCellDef data-header="prod-id"></th>
            <td mat-cell *matCellDef="let element" data-cell="prod-id">{{ element.productId }}</td>
          </ng-container>

          <!-- productName -->
          <ng-container matColumnDef="productName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by productName"
              data-header="product-name"
            >
              Product Name
            </th>
            <td mat-cell *matCellDef="let element" data-cell="product-name">
              {{ element.productName }}
            </td>
          </ng-container>

          <!-- categoryName -->
          <ng-container matColumnDef="categoryName">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by categoryName"
              data-header="category-name"
            >
              Category Name
            </th>
            <td mat-cell *matCellDef="let element" data-cell="category-name">
              {{ element.categoryName }}
            </td>
          </ng-container>

          <!-- description -->
          <ng-container matColumnDef="description">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by description"
              data-header="description"
            >
              Description
            </th>
            <td mat-cell *matCellDef="let element" data-cell="description">
              {{ element.description }}
            </td>
          </ng-container>

          <!-- isActive -->
          <ng-container matColumnDef="isActive">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by isActive"
              data-header="active"
            >
              Active
            </th>
            <td mat-cell *matCellDef="let element" data-cell="active">
              {{ element.isActive }}
            </td>
          </ng-container>

          <!-- isDeleted -->
          <ng-container matColumnDef="isDeleted">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              sortActionDescription="Sort by isDeleted"
              data-header="deleted"
            >
              Deleted
            </th>
            <td mat-cell *matCellDef="let element" data-cell="deleted">
              {{ element.isDeleted }}
            </td>
          </ng-container>

          <!-- createdBy -->
          <ng-container matColumnDef="createdBy">
            <th mat-header-cell *matHeaderCellDef data-header="created-by">CreatedBy</th>
            <td mat-cell *matCellDef="let element" data-cell="created-by">
              {{ element.createdBy }}
            </td>
          </ng-container>

          <!-- createdOn -->
          <ng-container matColumnDef="createdOn">
            <th mat-header-cell *matHeaderCellDef data-header="created-on">CreatedOn</th>
            <td mat-cell *matCellDef="let element" data-cell="created-on">
              {{ element.createdOn }}
            </td>
          </ng-container>

          <!-- updatedBy -->
          <ng-container matColumnDef="updatedBy">
            <th mat-header-cell *matHeaderCellDef data-header="updated-by">UpdatedBy</th>
            <td mat-cell *matCellDef="let element" data-cell="updated-by">
              {{ element.updatedBy }}
            </td>
          </ng-container>

          <!-- updatedOn -->
          <ng-container matColumnDef="updatedOn">
            <th mat-header-cell *matHeaderCellDef data-header="updated-on">UpdatedOn</th>
            <td mat-cell *matCellDef="let element" data-cell="updated-on">
              {{ element.updatedOn }}
            </td>
          </ng-container>

          <!-- Edit -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef data-header="edit">Edit</th>
            <td mat-cell *matCellDef="let element" data-cell="edit">
              <button
                mat-mini-fab
                aria-label="Edit"
                [disabled]="!isAdminGroupUser"
                (click)="onEditCategory($event, element)"
                data-btn="edit-category"
                data-extra="edit-cat"
              >
                <mat-icon>create</mat-icon>
              </button>
            </td>
          </ng-container>

          <!-- Delete -->
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef data-header="delete">Delete</th>
            <td mat-cell *matCellDef="let element" data-cell="delete">
              <button
                mat-mini-fab
                aria-label="Delete"
                color="warn"
                [disabled]="!isAdminGroupUser"
                (click)="onDeleteCategory($event, element)"
                data-btn="delete-category"
                data-extra="delete-cat"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" data-row="header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" data-row="data-row"></tr>
        </table>
      </div>

      <!-- Paginator -->
      <mat-paginator
        [length]="totalRows"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = $event; pageChanged($event)"
        data-element="paginator"
        data-meta="pagination-control"
      ></mat-paginator>

      <!-- Loader -->
      <div *ngIf="isLoaderResult" class="custSpinner" aria-busy="true" data-loader="true"></div>
    </mat-card-content>
  </mat-card>
</div>
